import styled from 'styled-components';

import {i18n} from '@yourcoach/i18n';

import TickSVG from '../../../assets/icons/primary/Tick Square.svg';
import {alert} from '../../../components/alert';
import {Title} from '../../../components/alert/components/Alert/styles';
import {ms} from '../../../styles';
import {View} from '../../../uikit/View';
import {isIamCoach} from '../isIamCoach';

export function showJoinProgramSuccessAlert(titles: string[]) {
  return alert.show({
    buttons: [
      {
        label: i18n.t('shared:great_excl'),
        scheme: 'gray',
      },
    ],
    icon: TickSVG,
    iconColor: isIamCoach() ? 'icon4' : 'icon5',
    isDismissible: true,
    renderTitle: () => (
      <TitleContainer>
        {titles.map((title, index) => (
          <View key={index}>
            <Title>{title}</Title>
          </View>
        ))}
      </TitleContainer>
    ),
  });
}

const TitleContainer = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
  column-gap: ${ms(4)};
  flex-direction: column;
`;
